import translate from '@allesauto/i18n';
import { addClass, removeClass } from '@allesauto/utils/funcs';
import { isAuregoShop } from '@allesauto/utils/funcs.ts';
import clsx from 'clsx';
import React, { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import {
  WL_INTEGRATION_SLUG_AUTO_HEMPEL,
  WL_INTEGRATION_SLUG_AUTOCENTER_DRESDEN,
  WL_INTEGRATION_SLUG_AUTOHAUS_BRUCKER,
} from 'web/src/features/whitelabel/util/getWhiteLabelIntegrationSlugs';

import Button from '../button';
import TextLink from '../textLink';
import { useWhiteLabel } from '../whiteLabel';

export type paramFilter = {
  setFilterVisible: (value: boolean) => void;
};

export interface MobileFilterProps {
  text?: string;
  param: paramFilter;
}

const MobileFilter: FC<MobileFilterProps> = ({ param }) => {
  const [filterButton, setFilterButton] = useState<boolean>(true);
  const [filterHeader, setFilterHeader] = useState<boolean>(false);
  const intl = useIntl();
  const whiteLabel = useWhiteLabel();

  const displayFiltersMenu = (overflow: string) => {
    param.setFilterVisible(!filterHeader);
    setFilterButton(!filterButton);
    setFilterHeader(!filterHeader);
    document.body.style.overflow = overflow;

    if (!isAutoHempelHeader()) {
      return;
    }
    overflow === 'hidden'
      ? addHiddenClassToAutoHempelLogo()
      : removeHiddenClassToAutoHempelLogo();
  };

  const addHiddenClassToAutoHempelLogo = () => {
    addClass('[data-autohempel-logo]', '!hidden');
    addClass('[data-autohempel-logo-2]', '!hidden');
  };

  const removeHiddenClassToAutoHempelLogo = () => {
    removeClass('[data-autohempel-logo]', '!hidden');
    removeClass('[data-autohempel-logo-2]', '!hidden');
  };

  const isAutoHempelHeader = () =>
    whiteLabel?.merchantOrigin === WL_INTEGRATION_SLUG_AUTO_HEMPEL;

  const isAutoCenterDresdenHeader =
    whiteLabel?.merchantOrigin === WL_INTEGRATION_SLUG_AUTOCENTER_DRESDEN;

  const isAutoBruckerHeader =
    whiteLabel?.merchantOrigin === WL_INTEGRATION_SLUG_AUTOHAUS_BRUCKER;

  useEffect(() => {
    if (window.screen.width < 1200) {
      addHiddenClassToAutoHempelLogo();
    } else {
      removeHiddenClassToAutoHempelLogo();
    }
    return () => {
      displayFiltersMenu('auto');
    };
  }, []);

  return (
    <>
      {filterHeader && (
        <div
          data-wl-mobile-filter
          className={clsx(
            whiteLabel ? 'h-[var(--wl-header-height)]' : 'h-[70px]',
            'bg-white flex items-center justify-between px-20px top-0 w-full sm:fixed sm:z-50 lg:hidden xl:-z-[1]',
            isAutoHempelHeader() &&
              'monochrome:max-[1042px]:h-[150px] monochrome:min-[1042px]:h-[160px] monochrome:max-[769px]:h-[181px] monochrome:max-[510px]:h-[156px] monochrome:max-[433px]:h-[144px] monochrome:max-[375px]:h-[136px]',
            isAutoBruckerHeader && ' monochrome:min-[100px]:h-[270px]  ',
            isAutoCenterDresdenHeader &&
              'monochrome:max-[718px]:h-[88px] monochrome:max-[991px]:h-[40px] monochrome:max-[1199px]:h-[200px]'
          )}
          style={{ borderBottom: '1px solid black' }}
        >
          <span className={'font-headline text-grey50 text-headline4'}>
            {translate(intl, 'ui.PCP.FILTERS.FILTER')}
          </span>
          <TextLink
            customClassName={`${
              isAuregoShop(whiteLabel) && '!text-white mobile-filter'
            }`}
            text={translate(intl, 'ui.PCP.FILTERS.MOBILE_CLOSE_BUTTON')}
            onClick={() => displayFiltersMenu('auto')}
          />
        </div>
      )}
      {filterButton && (
        <div className="z-50 sm:bottom-20px sm:fixed sm:right-[4.166%] md:bottom-60px lg:hidden">
          <Button
            text={translate(intl, 'ui.PCP.FILTERS.FILTER')}
            onClick={() => displayFiltersMenu('hidden')}
            customClassName={`${
              isAuregoShop(whiteLabel)
                ? '!text-white aurego-color monochrome:!text-white'
                : ' monochrome:text-black wl-bg-highlight wl-border-highlight'
            }`}
          />
        </div>
      )}
    </>
  );
};

export default MobileFilter;
